import { FacebookIcon } from "~/components/icons/facebook-icon";
import { InstagramIcon } from "~/components/icons/instagram-icon";
import { TwitterIcon } from "~/components/icons/twitter-icon";

export const socialMedia = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/triptojapancom",
    Icon: FacebookIcon,
  },
  {
    name: "Twitter",
    href: "https://twitter.com/triptojapan_",
    Icon: TwitterIcon,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/triptojapan_/",
    Icon: InstagramIcon,
  },
  // { name: "LinkedIn", href: "https://www.linkedin.com/company/trip-to-japan/" },
] as const;
